<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="header-bg">
  <div class="col-md-7  mx-auto text-center">

    <p class="font-weight-500 f-24">Get workforce insights and compare companies to inform your hiring and growth
      strategy.</p>
    <app-webbtree-company-search (keywordSearchInput)="getCompanySearch($event)"
      [searchFrom]="'search'"></app-webbtree-company-search>
  </div>
</div>
<app-webbtree-company-filters [filter]="filterObj"
  [totalCompanies]="formatNumberToIndianFormat(totalCompanies)" (filterInput)="onFilterInput($event)"></app-webbtree-company-filters>

<div class="row">
  <div class="col-md-9 pr-0">
    <!-- <div>
      <p class="f-14 font-weight-500 text-4848">{{formatNumberToIndianFormat(totalCompanies)}} Result</p>
    </div> -->
    <div *ngIf="companiesList?.length > 0 && !showCompanyListLoader">
      <div *ngFor="let company of companiesList; let i = index">
        <app-webbtree-company-details [companyDetails]="company"
          (buttonClicked)="onChildButtonClick($event, 'add')"></app-webbtree-company-details>
        <!-- Show sider div after every 5 items -->
        <div *ngIf="(i + 1) % 5 === 0">
          <app-company-comparison-slider [groupIndex]="(i + 1) / 5"></app-company-comparison-slider>
        </div>
      </div>
      <div class="text-center align-items-center p-3 wccard" (click)="viewMoreCompanies()"
        *ngIf="totalCompanies > companiesList?.length && totalCompanies > 21 && !showCompanyListLoader">
        <p class="f-16 text-webbtree-green font-weight-500 pointer mb-0">View more</p>
      </div>
    </div>

    <div class="wccard d-flex flex-column justify-content-center align-items-center"
      *ngIf="companiesList?.length == 0 && !showCompanyListLoader" style="height: calc(100vh - 45vh);">
      <div class="text-center">
        <img src="../../../assets/images/companyInsightsEmptystate.png" alt="img-fluid" class="img-config">
        <p class="f-14 font-weight-500 mb-0 text-center">No companies found. Adjust your filters to refine the search.
        </p>
      </div>
    </div>

    <div class="" *ngIf="showCompanyListLoader">
      <app-companylist-skeleton-loader></app-companylist-skeleton-loader>
    </div>
  </div>
  <!-- #sidebar  sidebar-->
  <div class="col ">
    <div class="aside-card">
      <img src="../../../assets/comppany-comparison/Competitive-Benchmark.svg" alt="">

      <div class="aside-content">
        <p>Competitive Benchmark</p>
        <span>See how companies stack up on key talent metrics to inform your strategy.</span>
        <div>
          <a data-testid="auto-app-webbtree-company-list-a-1" class="btn-trms-regular" target="_blank" target="_blank"
            href="https://fire-crib-a04.notion.site/Competitor-Talent-Benchmarking-216d71872fa580fd8ed6dd8a1ca0ddc9?source=copy_link">Learn
            More</a>
        </div>
      </div>
    </div>
    <div class="aside-card">
      <img src="../../../assets/comppany-comparison/Workforce-Demographics.svg" alt="">
      <div class="aside-content">
        <p>Workforce Demographics</p>
        <span>Understand company composition by gender, roles, and experience levels.</span>
        <div>
          <a data-testid="auto-app-webbtree-company-list-a-2" class="btn-trms-regular" target="_blank"
            href=" https://fire-crib-a04.notion.site/Software-Talent-in-India-A-Microsoft-Case-216d71872fa580538cc0c571367841ec?source=copy_link">Learn
            More</a>
        </div>
      </div>
    </div>
    <div class="aside-card">
      <img src="../../../assets/comppany-comparison/Growth-&-Hiring-Trends.svg" alt="">
      <div class="aside-content">
        <p>Growth & Hiring Trends</p>
        <span>Analyze hiring velocity, headcount growth, and future workforce projections.</span>
        <div>
          <a data-testid="auto-app-webbtree-company-list-a-3" class="btn-trms-regular" target="_blank"
            href=" https://fire-crib-a04.notion.site/Growth-and-Hiring-Trends-221d71872fa580fc9d88c81b0244eed1?source=copy_link">Learn
            More</a>
        </div>
      </div>
    </div>
    <div class="aside-card">
      <img src="../../../assets/comppany-comparison/Geographical-Insights.svg" alt="">
      <div class="aside-content">
        <p>Geographical Insights</p>
        <span>Explore where companies hire, grow, and concentrate their workforce globally.</span>
        <div>
          <a data-testid="auto-app-webbtree-company-list-a-4" class="btn-trms-regular" target="_blank"
            href="https://fire-crib-a04.notion.site/Geographic-Talent-Mapping-21dd71872fa580a2be41ce9281b9252e?source=copy_link">Learn
            More</a>
        </div>
      </div>
    </div>
    <div class="aside-card">
      <img src="../../../assets/comppany-comparison/Talent-Flow-&-Attrition.svg" alt="">
      <div class="aside-content">
        <p>Talent Flow & Attrition</p>
        <span>Track where talent comes from, where it’s going, and how companies retain it.</span>
        <div>
          <a data-testid="auto-app-webbtree-company-list-a-5" class="btn-trms-regular" target="_blank"
            href="https://fire-crib-a04.notion.site/Talent-Flow-Attrition-21dd71872fa5804fa827efacb18a42a3?source=copy_link">Learn
            More</a>
        </div>
      </div>
    </div>
    <div class="aside-card">
      <img src="../../../assets/comppany-comparison/Role-Level-Intelligence.svg" alt="">
      <div class="aside-content">
        <p>Role-Level Intelligence</p>
        <span>Drill down into specific functions to see who's hiring for what — and where.</span>
        <div>
          <a data-testid="auto-app-webbtree-company-list-a-6" class="btn-trms-regular" target="_blank"
            href="https://fire-crib-a04.notion.site/Role-Level-Intelligence-221d71872fa5805e831cc300dcde0278?source=copy_link">Learn
            More</a>
        </div>
      </div>
    </div>
    <!-- [ngClass]="isCollapsed ? 'stickybottom2' : '' " -->
    <div class="aside-card">
      <img src="../../../assets/comppany-comparison/University-&-Talent-Pipeline-Insights.svg" alt="">
      <div class="aside-content">
        <p>University & Talent Pipeline Insights</p>
        <span>See where companies source early talent and which schools feed into key roles.</span>
        <div>
          <a data-testid="auto-app-webbtree-company-list-a-7" class="btn-trms-regular" target="_blank"
            href="https://fire-crib-a04.notion.site/University-Talent-Pipeline-insights-221d71872fa580478347dbca8e4b0f29?source=copy_link">Learn
            More</a>
        </div>
      </div>
    </div>
    <!-- [ngClass]="isCollapsed ? 'stickybottom' : '' " -->
    <div class="aside-card" id="last-card" [ngClass]="isCollapsed ? 'stickybottom' : '' ">
      <img src="../../../assets/comppany-comparison/Skills-&-Role-Demand-Trends.svg" alt="">
      <div class="aside-content">
        <p>Skills & Role Demand Trends</p>
        <span>Identify in-demand skills and fast-growing roles across companies and industries.</span>
        <div>
          <a data-testid="auto-app-webbtree-company-list-a-8" class="btn-trms-regular" target="_blank"
            href="https://fire-crib-a04.notion.site/Skills-Role-Demand-Trends-221d71872fa58042b2d1df03787c463c?source=copy_link">Learn
            More</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" #stopper
  [ngClass]="{'d-flex': (btnCompareClicked || showFooter), 'd-none': (btnCompareClicked2 || !showFooter)}">
  <div class="col">
    <div class="wccard p-3"
      [ngClass]="{'bottom-stick-footer': (btnCompareClicked || showFooter), '': (btnCompareClicked2 || !showFooter)}">
      <app-webbtree-comapnylist-footer (buttonClicked)="onChildButtonClick($event, 'remove')"
        (footerStickOnSearchCompany)="oneCompanyAvailableInFooter($event)"></app-webbtree-comapnylist-footer>
    </div>
  </div>
</div>
